/**
 * Provide a default hook since not everyone need config this.
 */
var useDefaultCSP = function useDefaultCSP() {
  return {};
};
export default useDefaultCSP;